import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from '../../../../store/useCommonCodeStore';
import { defaultPRD4060_R01Filter, usePRD4060_R01Store } from "./Store_PRD4060_R01";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import {  searchLabelStyle, SearchSpacer } from "src/components/common/common";
import { CompanyDto } from "src/dtos/company/companyDto";
import { EmployeeDto } from "src/types/base";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

export const SearchSection_PRD4060_R01 = () => {

    const { setCodeSearchModalProps } = useUiuxStore();
	const { PRD4060_R01Filter, setPRD4060_R01Filter } = usePRD4060_R01Store();
	const { compCdList, downtimeValueList } = useCommonCodeStore();

	
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleWorkEmpFoucsId = 'workEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'productEmp',
			category: '작업자',
			focusId: handleWorkEmpFoucsId,
			responseMapping: {
				empNo: 'productEmp',
				empNm: 'productEmpNm',
			},
			searchFunction: async (searchText: string) => {
				const employeeResponse = await getEmployeeList(searchText);
				return employeeResponse.data.data.find(value => value.empNo === searchText);
			},
			extraFilter: () => ({
				productEmp: PRD4060_R01Filter.productEmp || '',
				productEmpNm: PRD4060_R01Filter.productEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD4060_R01Filter,
		setEditData: setPRD4060_R01Filter,
		defaultData: defaultPRD4060_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD4060_R01_search'
	});

    return (
        <div className="w-full ">
            <SearchSectionDoubleForm >
				<SearchDropDownForm
					label="사업장"
					value={PRD4060_R01Filter.compCd}
					onChangeItem={(item) => setPRD4060_R01Filter({ compCd: item?.compCd || ''})}
					optionList={compCdList}
				/>
				<SearchDateRangeForm
						label="작업일자"
						visible={pickerVisible}
						setVisible={setPickerVisible}
						dateRange={PRD4060_R01Filter.dateRange}
						setDateRange={v => setPRD4060_R01Filter({  dateRange: v})}
						pickerPosition={pickerPosition}
						setPickerPosition={setPickerPosition}
					/>
				<SearchDropDownForm
					label="비가동사유"
					value={PRD4060_R01Filter.downtimeCase}
					onChangeItem={(item) => setPRD4060_R01Filter({ downtimeCase: item?.minorCd || ''})}
					optionList={downtimeValueList}
					editable={true}
					wrapperOption={{
						wrapperStyle: "w-[300px] min-w-[300px] mr-[10px]",
						titleStyle: "w-[70px] min-w-[70px] text-left",
						selectStyle: "w-[150px] min-w-[150px]",
					}}
				/>
				<SearchCodeModalForm
					label="작업자"
					value={PRD4060_R01Filter.productEmp}
					valueLabel={PRD4060_R01Filter.productEmpNm}
					handleFoucsId={handleWorkEmpFoucsId}
					onChange={getFieldHandlers('productEmp').onChange}
					onDoubleClick={getFieldHandlers('productEmp').onDoubleClick}
					onKeyDown={getFieldHandlers('productEmp').onEnterKeyDown}
					wrapperOption={{
						wrapperStyle: "w-[300px] min-w-[300px] mr-[10px]",
						titleStyle: "w-[40px] min-w-[40px] text-left",
						codeInputStyle: "w-[100px] min-w-[100px]",
						nameTagStyle: "w-[150px] min-w-[150px] text-left",
					}}
				/>
            </SearchSectionDoubleForm>
        </div>
    );
};

